import React from 'react';
import classnames from 'classnames';
import { objectUtils } from '@codametrix/ui-common';
import { PropertyAccessor } from './propery-accessor';

export const NA = 'N/A';

export const propAccessor2 = (
  detail: CMxCommonApp.ExtendedCaseRun,
  propertyActivations: CMxCommonApp.PropertyActivations
): PropertyAccessor => {
  return (propPath: string, altValue: any = NA) => {
    const prop = objectUtils.get(detail, propPath, altValue);
    const activations = objectUtils.get(
      propertyActivations,
      propPath,
      []
    ) as CMxCommonApp.ChargeSessionEvidence[];

    const visible = activations.some(
      activation => activation.selectionState.visible
    );
    if (!visible) {
      return prop !== null ? prop : altValue;
    }

    let highlighted: JSX.Element = prop;
    activations.forEach(activation => {
      const active = activation.selectionState.active;

      const styleClasses = [
        `evidence`,
        'highlighted-text',
        {
          'evidence-categorical': true,
          'qa-evidence-categorical': true,
          'evidence-active': active,
          'qa-evidence-active': active
        },
        `evidence-${activation.meta.codeType}`,
        `evidence-${activation.meta.provenance}`
      ];

      highlighted = (
        <span className={classnames(styleClasses)}>{highlighted}</span>
      );
    });

    return highlighted;
  };
};
